var _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-align-right",
    width: 40,
    height: 45,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#e83283",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 6,
    x2: 20,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 12,
    x2: 20,
    y2: 12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 18,
    x2: 20,
    y2: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.300254aa7e98d76836daf23455e6fd49.svg";
export { ForwardRef as ReactComponent };